export default "__VITE_ASSET__Dz2$IuEO__"